import React from 'react';
import { useJaws } from '@oms/jaws-react';
import { getCostAndChargesPDFURL } from 'utils/modelity';

export const CostAndChargesLink = ({ itemSector, ...props }) => {
  const { items, isFetching } = useJaws({
    columns: 'ISIN, INSTRUMENT_TYPE',
    itemSector,
  });

  if (isFetching || !itemSector) return null;

  const { ISIN, INSTRUMENT_TYPE } = items.first()?.toJS() || {};
  if (!['ETNS', 'WARRANTS'].includes(INSTRUMENT_TYPE)) return null;

  return (
    <a
      {...props}
      href={getCostAndChargesPDFURL({ isin: ISIN })}
      target="_blank"
      rel="noreferrer"
    >
      Detaljerte kostnader
    </a>
  );
};
